import {
  NUMBER_ANIMATION_DURATION
} from '@/assets/js/highlight/config'

const numberAnimation = (
  number
) => (
  new TimelineMax()
    .to(number, NUMBER_ANIMATION_DURATION, { top: '0' })
)

export default numberAnimation



// WEBPACK FOOTER //
// ./src/assets/js/highlight/number.js